<template>
  <layout-content :title="title">
    <div :class="`${need_show_tutorial ? 'overlay-blur' : ''}`"></div>

    <router-link
      v-if="counter === 1"
      :class="`${need_show_tutorial ? 'tutorial-breadcrumb' : ''}`"
      :to="{ name: 'autoinformer.campaign.index', params: { tutorial: true, counter: 2 } }"
    >
      {{ $t('autoinformer.breadcrumb.campaign.index') }}
    </router-link>
    <template slot="header">
      {{ $t(`${$route.meta.title['code']}`, { name: title }) }}
    </template>

    <div slot="top-buttons" :class="`${need_show_tutorial ? 'tutorial-form' : ''}`">
      <div :class="computed_class" :title="tutorial_steps[counter].text">
        <i-button size="large" type="primary" @click="create">
          {{ $t('autoinformer.task.button.create') }}
        </i-button>
      </div>
    </div>

    <table-component />
  </layout-content>
</template>

<script>
  import TableComponent from '@autoinformer/components/tasks-table';
  import { CampaignsService } from '@autoinformer/services/CampaignsService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      TableComponent
    },
    data() {
      return {
        title: '',
        need_show_tutorial: false,
        counter: 0,
        tutorial_steps: [
          { id: 'create', text: 'Нажмите “Добавить задачу”' },
          {
            id: 'list',
            text: 'Задача добавлена, вернитесь на страницу “Кампании” и запустите кампанию.'
          }
        ]
      };
    },
    computed: {
      computed_class: function () {
        return this.need_show_tutorial && this.tutorial_steps[this.counter].id === 'create'
          ? 'hint hint--bottom'
          : '';
      }
    },
    created() {
      this.getCampaign();
      this.need_show_tutorial = !!this.$route.params?.tutorial;
      if (this.$route.params?.counter) {
        this.counter = this.$route.params?.counter;
      }
    },
    methods: {
      ...mapActions('autoinformer/campaigns/tasks/table', ['getAsyncData']),
      getCampaign() {
        CampaignsService.getItem(this.$route.params.id,).then((response) => {
          this.title = response.name;
        });
      },
      create() {
        this.$router.push({
          name: 'autoinformer.campaign.tasks.create',
          params: { tutorial: this.need_show_tutorial }
        });
        // TaskModalService.create(this.$route.params.id).on('success', () => this.getAsyncData());
      }
    }
  };
</script>

<style lang="scss">
  .tutorial-breadcrumb {
    position: absolute;
    background: #fff;
    border-radius: 2px;
    padding: 0px 4px;
    left: 518px;
    top: 140px;
    z-index: 100;
    
  }
  .tutorial-form {
    .hint--bottom {
      z-index: 100;

      &:before {
        left: -143px;
        top: -110px;
        transform: rotate(300deg);
      }
      &:after {
        left: -70px;
        top: 170%;
      }
    }
  }
</style>
